import React, { useEffect, useState } from "react";
import HomeService from "../../Services/HomeService";

const FAQ = () => {
  const [faqs, setFaqs] = useState([]);

  const fetchFaqs = async () => {
    try {
      const res = await HomeService?.getFaqs();
      console.log("Faq", res);
      if (res?.status) {
        setFaqs(res?.data);
      } else {
        console.log(res);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchFaqs();
  }, []);

  return (
    <>
      <div className="wall_of_fame_wrapper">
        <div className="search_cities_div">
          <h1>Frequently Asked Questions</h1>

          <div class="accordion" id="accordionPanelsStayOpenExample">
            {faqs?.map((e, i) => {
              return (
                <div class="accordion-item">
                  <h2
                    class="accordion-header"
                    id={`panelsStayOpen-heading${i + 1}`}
                  >
                    <button
                      class="accordion-button"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target={`#panelsStayOpen-collapse${i + 1}`}
                      aria-expanded="true"
                      aria-controls={`panelsStayOpen-collapse${i + 1}`}
                    >
                      {e?.question}
                    </button>
                  </h2>
                  <div
                    id={`panelsStayOpen-collapse${i + 1}`}
                    // class="accordion-collapse collapse show"
                    class="accordion-collapse collapse "
                    aria-labelledby={`panelsStayOpen-heading${i + 1}`}
                  >
                    <div class="accordion-body">
                      {/* <strong>This is the first item's accordion body.</strong>{" "} */}
                      {e?.answer}
                    </div>
                  </div>
                </div>
              );
            })}

            {/* <div class="accordion-item">
              <h2 class="accordion-header" id="panelsStayOpen-headingTwo">
                <button
                  class="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#panelsStayOpen-collapseTwo"
                  aria-expanded="false"
                  aria-controls="panelsStayOpen-collapseTwo"
                >
                  Accordion Item #2
                </button>
              </h2>
              <div
                id="panelsStayOpen-collapseTwo"
                class="accordion-collapse collapse"
                aria-labelledby="panelsStayOpen-headingTwo"
              >
                <div class="accordion-body">
                  <strong>This is the second item's accordion body.</strong> It
                  is hidden by default, until the collapse plugin adds the
                  appropriate classes that we use to style each element. These
                  classes control the overall appearance, as well as the showing
                  and hiding via CSS transitions. You can modify any of this
                  with custom CSS or overriding our default variables. It's also
                  worth noting that just about any HTML can go within the{" "}
                  <code>.accordion-body</code>, though the transition does limit
                  overflow.
                </div>
              </div>
            </div>
            <div class="accordion-item">
              <h2 class="accordion-header" id="panelsStayOpen-headingThree">
                <button
                  class="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#panelsStayOpen-collapseThree"
                  aria-expanded="false"
                  aria-controls="panelsStayOpen-collapseThree"
                >
                  Accordion Item #3
                </button>
              </h2>
              <div
                id="panelsStayOpen-collapseThree"
                class="accordion-collapse collapse"
                aria-labelledby="panelsStayOpen-headingThree"
              >
                <div class="accordion-body">
                  <strong>This is the third item's accordion body.</strong> It
                  is hidden by default, until the collapse plugin adds the
                  appropriate classes that we use to style each element. These
                  classes control the overall appearance, as well as the showing
                  and hiding via CSS transitions. You can modify any of this
                  with custom CSS or overriding our default variables. It's also
                  worth noting that just about any HTML can go within the{" "}
                  <code>.accordion-body</code>, though the transition does limit
                  overflow.
                </div>
              </div>
            </div> */}
          </div>
        </div>
      </div>
    </>
  );
};

export default FAQ;
